import { Stack } from '@chakra-ui/react';
import * as React from 'react';

import { FileUploadPreviewItem } from './components/FileUploadPreviewItem';

export const FileUploadPreview: React.FC<{
  attachments: {
    versionFileId: string;
    fileName: string;
  }[];
  onClick: (value: { versionFileId: string }) => void;
}> = (props) => {
  return !!props.attachments.length ? (
    <Stack>
      {props.attachments.map((file) => (
        <FileUploadPreviewItem
          key={file.fileName}
          fileName={file.fileName}
          versionFileId={file.versionFileId}
          onClick={props.onClick}
        />
      ))}
    </Stack>
  ) : null;
};
